<template>
  <div v-if="kotNo">
    <div class="ticket">
      <!-- <p class="centered" style="margin-bottom: 10px">
        <span >{{ name }}</span> <br />
      </p> -->

      <p>
        KOT No : {{ kotNo }} <br />Date :
        {{ date }} <br />Table : {{ table }}
        <!-- <br />Customer : {{ customerName }} -->
      </p>
      <table style="margin-top: -30px">
        <thead>
          <tr style="border-top: hidden">
            <th class="description" style="text-align: left">Item</th>
            <th class="quantity" style="text-align: left">Qty</th>
            
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products" :key="product.barcode">
            <td class="description">{{ product.item }}</td>
            <td class="quantity">{{ product.quantity }}</td>
          </tr>
          <tr>
            <br />
          </tr>
          
          <tr>
            <br />
          </tr>
        </tbody>
      </table>
      <p class="centered" style="margin-bottom: 10px">
        {{ note }}
      </p>
      
    </div>
  </div>
</template>

<script>

export default {
  name: "posprinter",
  props: [
    "products",
    "kotNo",
    "table",
    "date",
    // "name",
    "note",
  ],
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped>
td,
th,
tr,
table {
  border-top: 1px dotted rgb(49, 49, 49);
  border-collapse: collapse;
}
.centered {
  text-align: center;
  align-content: center;
}

* {
  font-size: 12px;
  font-family: "Times New Roman";
}
td.description,
th.description {
  width: 80px;
  max-width: 85px;
}

td.quantity,
th.quantity {
  width: 30px;
  max-width: 30px;
  word-break: break-all;
}

td.unitprice,
th.unitprice {
  width: 45px;
  max-width: 45px;
  word-break: break-all;
}

td.price,
th.price {
  width: 45px;
  max-width: 45px;
  word-break: break-all;
}

.ticket {
  /* width: 185px;
  max-width: 185px; */
  width: 200px;
  max-width: 200px;
}

/* * {
  font-size: 18px;
  font-family: "Times New Roman";
}

td.description,
th.description {
  width: 320px;
  max-width: 320px;
}

td.quantity,
th.quantity {
  width: 120px;
  max-width: 120px;
  word-break: break-all;
}

td.unitprice,
th.unitprice {
  width: 180px;
  max-width: 180px;
  word-break: break-all;
}

td.price,
th.price {
  width: 180px;
  max-width: 180px;
  word-break: break-all;
}

.ticket {
  width: 800px;
  max-width: 800px;
  margin: 0 auto;
} */

img {
  max-width: 180px;
  width: 180px;
  display: block;
  margin: 0 auto;
}

@media print {
  .hidden-print,
  .hidden-print * {
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/InvoiceTemplates/KOTPrint.vue